











































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Salon } from "@/models/salon";

@Component
export default class SalonComponent extends Vue {
  @Prop({ default: new Salon() })
  pSalon!: Salon;
  @Prop({ default: "" })
  pTitle!: string;
  @Prop({ default: "" })
  pTicketNumberStr!: string;

  get getUrl(): string {
    return window.location.href;
  }
  get getTitle(): string {
    // タイトル文字をエスケープする
    return encodeURIComponent(this.pTitle);
  }

  gotoSalonDetail() {
    const salon_id = this.$store.getters.salonId
    if (this.$route.name === "SalonDetail") {
       this.$router.go(0);
    } else {
      this.$router.push({ name: "SalonDetail", params: { salon_id: salon_id }});
    }
  }

  get station(): string {
    let stationStr = "最寄駅なし";
    if (this.pSalon.nearest_station_1) {
      stationStr = this.pSalon.nearest_station_1;
    }
    if (this.pSalon.nearest_station_2) {
      stationStr += "、" + this.pSalon.nearest_station_2;
    }
    if (this.pSalon.nearest_station_3) {
      stationStr += "、" + this.pSalon.nearest_station_3;
    }
    return stationStr;
  }

  get address() {
    const prefecture = this.pSalon.prefecture || "";
    const city = this.pSalon.city || "";
    const address = this.pSalon.address || "";
    const building = this.pSalon.building || "";
    return `${prefecture} ${city} ${address} ${building}`;
  }

  googleMapUrl(address: string): string {
    const query = encodeURI(address);
    const google = "https://maps.google.co.jp/maps?q=";
    const url = google + query;
    return url;
  }

  telUrl(tel: string): string {
    return "tel:" + tel;
  }
}
